export enum SettingsOptions {
  TEAM_MEMBERS = 'Team members',
  ROLE_PERMISSIONS = 'Role permissions',
  ROLES_MANAGE = 'Roles',
  COST_CENTER = 'Cost Center'
}
